module.exports = __webpack_public_path__ + "static/media/Internsuit.760e7656.png";